import { _breakP } from './utils.js';
import { clearAllBodyScrollLocks, disableBodyScroll } from 'body-scroll-lock';

/**
 * 汎用モーダル制御（movie.js / shinagawa lib/modal.js と同型）
 * フック: .js-modal（ラッパ）/ .js-modalBtn（トリガー）/ .js-modalCont（generalModal）/ .js-modalClose / .js-modalInner
 * .js-modalCont を .currentPage 直下へ移動し、is-visible で開閉。Esc・フォーカストラップ・body スクロールロック対応。
 * data-modal-device="pc|sp" で対象デバイスを限定可。
 */
export default class Modal {
  constructor() {
    this.modalAction();
  }

  modalAction() {
    const $modal = document.querySelectorAll('.js-modal');
    if (!$modal.length) return;

    function modalContDOMMove(e, i) {
      const $modalDomMovedPoint = document.querySelector('.currentPage');
      const $modalCont = e.querySelector('.js-modalCont');
      if (!$modalDomMovedPoint || !$modalCont) return null;
      $modalCont.classList.add(`js-modalCont--${i}`);
      // 既存 DOM ノードをそのまま移動（outerHTML 往復は XSS sink でリスナーも失うため避ける）
      $modalDomMovedPoint.prepend($modalCont);
      return $modalCont;
    }

    $modal.forEach((modalElm, index) => {
      const modalStruct = () => {
        const $modalCont = modalContDOMMove(modalElm, index);
        if (!$modalCont) return;
        const $modalBtn = modalElm.querySelectorAll('.js-modalBtn');
        const $closeBtn = $modalCont.querySelectorAll('.js-modalClose');
        let $lastFocusedElm;
        let escapeHandler = null;

        const modalClose = () => {
          if ($lastFocusedElm) $lastFocusedElm.focus();
          $modalCont.classList.remove('is-visible');
          $modalCont.setAttribute('aria-hidden', 'true');
          $modalCont.setAttribute('aria-modal', 'false');
          $modalCont.setAttribute('hidden', 'hidden');
          for (let i = 0; i < $modalBtn.length; i++) {
            $modalBtn[i].setAttribute('aria-expanded', 'false');
          }
          for (let i = 0; i < $closeBtn.length; i++) {
            $closeBtn[i].setAttribute('aria-hidden', 'true');
            $closeBtn[i].setAttribute('tabindex', '-1');
          }
          clearAllBodyScrollLocks();
          document.documentElement.style.overflow = '';

          if (escapeHandler) {
            document.removeEventListener('keydown', escapeHandler);
            escapeHandler = null;
          }
        };

        const modalOpen = () => {
          $lastFocusedElm = document.activeElement;
          $modalCont.classList.add('is-visible');
          $modalCont.setAttribute('aria-hidden', 'false');
          $modalCont.setAttribute('aria-modal', 'true');
          $modalCont.removeAttribute('hidden');

          const $target = $modalCont.querySelector('.js-modalInner');
          for (let i = 0; i < $modalBtn.length; i++) {
            $modalBtn[i].setAttribute('aria-expanded', 'true');
          }
          for (let i = 0; i < $closeBtn.length; i++) {
            $closeBtn[i].setAttribute('aria-hidden', 'false');
            $closeBtn[i].setAttribute('tabindex', '0');
          }

          const $focusItem = $modalCont.querySelectorAll("button, [href], input, select, textarea, [tabindex]:not([tabindex='-1'])");
          setTimeout(() => {
            if ($focusItem[0]) $focusItem[0].focus();
          }, 10);

          $modalCont.addEventListener('keydown', (event) => {
            if (event.key === 'Tab') {
              if (document.activeElement === $focusItem[$focusItem.length - 1] && !event.shiftKey) {
                event.preventDefault();
                $focusItem[0].focus();
              }
            }
          });

          escapeHandler = (event) => {
            if (event.key === 'Escape' && $modalCont.classList.contains('is-visible')) {
              modalClose();
            }
          };
          document.addEventListener('keydown', escapeHandler);

          if ($target) disableBodyScroll($target);
          document.documentElement.style.overflow = 'hidden';
        };

        $modalCont.setAttribute('id', `general-modal-${index}`);

        $modalBtn.forEach((elm) => {
          elm.setAttribute('aria-controls', `general-modal-${index}`);
          elm.addEventListener('click', (event) => {
            event.preventDefault();
            modalOpen();
          });
        });

        $closeBtn.forEach((elm) => {
          elm.addEventListener('click', (event) => {
            event.preventDefault();
            modalClose();
          });
        });
      };

      const modalDisable = () => {
        const $modalBtn = modalElm.querySelectorAll('.js-modalBtn');
        for (let i = 0; i < $modalBtn.length; i++) {
          $modalBtn[i].setAttribute('tabindex', '-1');
        }
        const $modalCont = modalElm.querySelector('.js-modalCont');
        if ($modalCont) $modalCont.classList.add('is-disable');
      };

      if (modalElm.dataset.modalDevice === 'sp') {
        _breakP.SP ? modalStruct() : modalDisable();
      } else if (modalElm.dataset.modalDevice === 'pc') {
        !_breakP.SP ? modalStruct() : modalDisable();
      } else {
        modalStruct();
      }
    });
  }
}
